// /auth/verify?token=… — completes the magic-link sign-in (a POST from this page, so link
// scanners in mail clients can't use up the token), then asks for a nickname if needed.
import { useEffect, useRef, useState } from "react";
import { ApiError } from "../api";
import { Link, navigate, useSearch, useTitle } from "../lib/router";
import { verifyToken } from "../session";

export function Verify() {
  useTitle("Signing in");
  const params = useSearch();
  const [error, setError] = useState("");
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token") ?? "";
    const next = params.get("next") ?? "/";
    const safeNext = next.startsWith("/") && !next.startsWith("//") ? next : "/";
    verifyToken(token)
      .then((r) =>
        navigate(r.needsNickname ? `/account?welcome=1&next=${encodeURIComponent(safeNext)}` : safeNext, {
          replace: true,
        }),
      )
      .catch((e) => setError(e instanceof ApiError ? e.message : "Sign-in failed."));
  }, [params]);
  return (
    <main id="main" className="page narrow">
      {error ? (
        <div className="panel stack">
          <h1>That didn't work</h1>
          <p role="alert">{error}</p>
          <Link className="btn" href="/signin">
            Get a new link
          </Link>
        </div>
      ) : (
        <p className="muted">Signing you in…</p>
      )}
    </main>
  );
}
